import { DATA_STATE } from "@plugins/modal/modal.constant";
import contentSubpageEventBus from "@plugins/content-subpage/service/event-bus.ts";
import PageDirtyMixin from "@modules/app/mixin/page.dirty.mixin";

export default {
  mixins: [PageDirtyMixin],
  data() {
    return {
      dataSaveButton: {
        kind: "primary",
        size: "field",
        error: false,
        loading: false,
        completed: false,
        iconOnly: true,
        tipPosition: "bottom",
        errorMessage: "",
        iconName: "Save24",
      },
      defaultErrorMessage: "",
      visible: true,
      titles: [],
      hasParentSubpage: false,
      ignoreActionHidden: false,
      ignoreActionBack: false,
    };
  },
  methods: {
    setVisible(visible) {
      this.visible = visible;
    },
    actionHiddenCallBack() {
      if (
        !this.ignoreActionHidden &&
        typeof this.params.actionHidden !== "undefined" &&
        typeof this.params.actionHidden === "function"
      ) {
        this.params.actionHidden();
      }
    },
    actionBackCallBack() {
      if (
        !this.ignoreActionBack &&
        typeof this.params.actionBack !== "undefined" &&
        typeof this.params.actionBack === "function"
      ) {
        this.params.actionBack();
      }
    },
    actionHidden() {
      contentSubpageEventBus.$emit("content-subpage-hidden", this.$.vnode.key);
    },
    actionBack() {
      contentSubpageEventBus.$emit("content-subpage-back", this.$.vnode.key);
    },
    getDataState() {
      if (this.dataSaveButton.loading) {
        return DATA_STATE.LOADING;
      } else if (this.dataSaveButton.completed) {
        return DATA_STATE.COMPLETED;
      } else if (this.dataSaveButton.error) {
        return DATA_STATE.ERROR;
      } else {
        return DATA_STATE.DEFAULT;
      }
    },
    setDataState(state) {
      this.resetDataState();
      switch (state) {
        case DATA_STATE.LOADING:
          this.dataSaveButton.loading = true;
          return;
        case DATA_STATE.LOADED:
          this.dataSaveButton.loading = false;
          return;
        case DATA_STATE.COMPLETED:
          this.dataSaveButton.loading = false;
          this.dataSaveButton.completed = true;
          return;
        case DATA_STATE.ERROR:
          this.dataSaveButton.loading = false;
          this.dataSaveButton.error = true;
          return;
      }
    },
    setErrorMessage(message) {
      this.dataSaveButton.errorMessage = message;
    },
    handleSaveButtonResetError() {
      this.dataSaveButton.loading = false;
      this.dataSaveButton.error = false;
      this.dataSaveButton.errorMessage = this.defaultErrorMessage;
    },
    handleSaveButtonResetCompleted() {
      this.dataSaveButton.loading = false;
      this.dataSaveButton.completed = false;
    },
    resetDataState() {
      this.dataSaveButton.completed = false;
      this.dataSaveButton.error = false;
      this.dataSaveButton.errorMessage = this.defaultErrorMessage;
    },
  },
  created() {
    this.titles =
      this.params && this.params.baseTitle ? Object.assign([], this.params.baseTitle) : [];
    this.hasParentSubpage =
      this.params && this.params.hasParentSubpage ? this.params.hasParentSubpage : false;

    this.dataSaveButton.errorMessage = this.$i18n.t("api_fetch_generic_error_message");
    this.defaultErrorMessage = this.$i18n.t("api_action_generic_error_message");
  },
};
